import { LOYALTY_SERVICE_URL } from "@/Constants";
import { createApiInstance } from "@/lib/services/createAPIInstance.ts";

export default createApiInstance(LOYALTY_SERVICE_URL);
